import { useGet, UseGetReturnType } from '../../../../api';
import { USER_MANAGEMENT_BASE_URL } from '../consts';

export interface GetEnrollmentCompanyLogoUrlDto {
    companyLogoUrl: string;
}

type ReturnType = Omit<UseGetReturnType<GetEnrollmentCompanyLogoUrlDto>, 'data'> & {
    companyLogoUrl?: string;
};

export const useGetEnrollmentCompanyLogoUrl = (): ReturnType => {
    const { data, ...restValues } = useGet<GetEnrollmentCompanyLogoUrlDto>({
        url: `${USER_MANAGEMENT_BASE_URL}/enrollmentEmails/companyLogoUrl`
    });

    return {
        ...restValues,
        companyLogoUrl: data?.companyLogoUrl
    };
};
